define('home/views/DiscussionsModuleItemView',[
    'backbone-marionette',
    'home/utils/layoutUtils',

    'home/templates/discussionsModuleItem',
], function (
    Marionette,
    layoutUtils,

    discussionsModuleItemTemplate
) {
    'use strict';

    /**
     * A single item in a discussions module.
     *
     * Expects an ActivityFeedItem model that has a related thread model.
     */
    var DiscussionsModuleItemView = Marionette.ItemView.extend({
        className: 'post-comments__wrapper',

        template: discussionsModuleItemTemplate,
        templateHelpers: function () {
            var thread = this.model.thread;
            return {
                image: thread && thread.getImage(),
                numTitleLines: 3,
                canShowThreadImage: !layoutUtils.isNarrowLayout(),
            };
        },
    });

    return DiscussionsModuleItemView;
});

